import { withScrollRestoration } from '@/shared/hocs/withScrollRestoration';

import './index.css';

interface SplitLayoutProps {
    customLeftClassNames?: Array<string>;
    customRightClassNames?: Array<string>;
    useDefaultStyles?: boolean;
    sideContent: React.ReactNode;
    mainContent: React.ReactNode;
    extraContent?: React.ReactNode;
    breakPoint?: number;
    className?: string;
    dataTestid?: string;
}

export const _SplitLayout: React.FC<SplitLayoutProps> = ({
    customLeftClassNames = [],
    customRightClassNames = [],
    useDefaultStyles = true,
    sideContent = null,
    mainContent = null,
    extraContent = null,
    className,
    dataTestid
}) => {
    let leftContainerClass = 'splitContainer__left';
    let rightContainerClass = 'splitContainer__right';
    if (!useDefaultStyles) {
        leftContainerClass = '';
        rightContainerClass = '';
    }
    if (customLeftClassNames.length > 0) {
        leftContainerClass += ` ${customLeftClassNames.join(' ')}`;
    }
    if (customRightClassNames.length > 0) {
        rightContainerClass += ` ${customRightClassNames.join(' ')}`;
    }
    return (
        <div className={`splitContainer ${className}`} data-testid={dataTestid || 'split-layout-container'}>
            <div data-testid="split-layout-side-content" className={leftContainerClass}>{sideContent}</div>
            <div data-testid="split-layout-main-content" className={rightContainerClass}>{mainContent}</div>
            {extraContent}
        </div>
    );
};

export const SplitLayout = withScrollRestoration(_SplitLayout);

export default SplitLayout;
